




















































import Vue from 'vue';
import { VBTooltip, BProgress, BProgressBar } from 'bootstrap-vue';

import ZenButton from '@reciprocity/button';
import { FetcherTask, Fetcher } from './types';

export default Vue.extend({
  name: 'FetcherAction',
  components: {
    BProgress,
    BProgressBar,

    ZenButton,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    task: {
      type: Object as () => FetcherTask,
      required: false,
      default: null,
    },
    fetcher: {
      type: Object as () => Fetcher,
      required: true,
    },
  },
});
